// extracted by mini-css-extract-plugin
export default {"panel":"panel-module--panel--ddb62"};